import React from 'react';
import { User, Search, SquarePlus, Compass, Share2 } from 'lucide-react';
import './buttonBar.scss';

const NAV_ITEMS = [
  { id: 'profile', label: 'پروفایل', icon: User },
  { id: 'search', label: 'جستجو', icon: Search },
  { id: 'add', label: 'افزودن', icon: SquarePlus },
  { id: 'explore', label: 'اکسپلور', icon: Compass },
  { id: 'share', label: 'اشتراک‌گذاری', icon: Share2 },
];

function ButtonBar({ activeId, onSelect }) {
  return (
    <nav className="button-bar" aria-label="منوی اصلی">
      {NAV_ITEMS.map(({ id, label, icon: Icon }) => {
        const isActive = activeId === id;
        return (
          <button
            key={id}
            type="button"
            className={`button-bar__item ${isActive ? 'is-active' : ''}`}
            onClick={() => onSelect?.(id)}
            aria-label={label}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon
              size={25}
              strokeWidth={isActive ? 2 : 1.6}
              fill={isActive ? 'currentColor' : 'none'}
            />
          </button>
        );
      })}
    </nav>
  );
}

export default ButtonBar;